// extracted by mini-css-extract-plugin
export var icon = "illustration-module--icon--3d3d3";
export var iconWrapper = "illustration-module--iconWrapper--47b3f";
export var iconWrapper__l = "illustration-module--iconWrapper__l--84c5f";
export var iconWrapper__m = "illustration-module--iconWrapper__m--e2b63";
export var icon__l = "illustration-module--icon__l--b084f";
export var icon__m = "illustration-module--icon__m--be9af";
export var spin = "illustration-module--spin--65da1";